module.exports = __webpack_public_path__ + "img/icon-white-23.61510a40.svg";